/**
 * Si un agente está asignado a UN solo establecimiento o a varios.
 *
 * Los códigos son los del back, confirmados contra la respuesta de RNHAgenteGet:
 * el campo es `rnhAgenteEstablecimientoUnico` y es una bandera Y/N, no un 1/0.
 * ("N" = no es único = está en varios lados).
 *
 * Vive acá y no en la carpeta del ABM porque lo comparten el select de los modales
 * (pages/programa-salud/personal/agentes) y la columna "U" de la grilla
 * (consts/titulos-de-tablas). Mismo criterio que consts/estados-agente y consts/leyes.
 */
export const ASIGNACIONES = [
    { cod: "Y", label: "Única" },
    { cod: "N", label: "Múltiple" },
];

/**
 * Sí / No para la columna "U" de la grilla.
 *
 * NO reusa el `label` de arriba a propósito. Es el mismo dato respondiendo dos preguntas
 * distintas:
 *
 *   En el select  ->  "¿qué tipo de asignación tiene?"   ->  Única / Múltiple
 *   En la columna ->  el encabezado ya dice "U" (única)  ->  Sí / No
 *
 * Poner "Única" debajo de una columna llamada "U" es repetir la pregunta en vez de
 * contestarla, y además no entra: la columna mide 60px.
 *
 * Si el código no está en la tabla devuelve el CRUDO en vez de vacío. Es a propósito:
 * de la respuesta real solo vimos el "N", así que el "Y" para única está inferido de
 * cómo el back maneja otras banderas (`rnhTituloRequiereMatricula === "Y"`). Si en
 * realidad manda "S", la celda va a mostrar "S" —raro pero visible— en vez de quedar
 * en blanco y hacernos creer que el dato no viene.
 */
const SI_NO = { Y: "Sí", N: "No" };

export const etiquetaUnico = (cod) => SI_NO[cod] ?? (cod ?? "");
